import { Component, Input, OnInit } from '@angular/core';
import { ListTableComponent } from '@ppl/ui';

@Component({
  selector: 'ppl-view-claim-timesheets',
  standalone: true,
  imports: [ListTableComponent],
  templateUrl: './view-claim-timesheets.component.html',
  styleUrl: './view-claim-timesheets.component.css',
})
export class ViewClaimTimesheetsComponent implements OnInit {
  detailsCols = [
    {
      field: 'id',
      header: 'Timesheet ID',
      jsonpath: 'id',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'status',
      header: 'Adjustment Response',
      jsonpath: 'status',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
  ];

  @Input() claimTSData: any;
  @Input() errorCode: any;

  ngOnInit(): void {}
}
